export default {
  applicationList: state => state.applicationList,
  applicationListLoading: state => state.applicationListLoading,
  applicationListMessage: state => state.applicationListMessage,

  recipientsList: state => state.recipientsList,
  recipientsListLoading: state => state.recipientsListLoading,
  recipientsListMessage: state => state.recipientsListMessage,

  originalRecipientsList: state => state.originalRecipientsList,
  completedRecipientsList: state => state.recipientsList.filter(r => r.completedDate !== null),
  pendingRecipientsList: state => state.recipientsList.filter(r => r.completedDate === null),
  resendEmailLoading: state => state.resendEmailLoading
}
